var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1996 25.6004H9.59961V22.4004H11.1996C11.624 22.4004 12.0309 22.569 12.331 22.869C12.631 23.1691 12.7996 23.576 12.7996 24.0004C12.7996 24.4247 12.631 24.8317 12.331 25.1318C12.0309 25.4318 11.624 25.6004 11.1996 25.6004ZM22.3996 32.0004V22.4004H23.9996C24.424 22.4004 24.8309 22.569 25.131 22.869C25.431 23.1691 25.5996 23.576 25.5996 24.0004V30.4004C25.5996 30.8247 25.431 31.2317 25.131 31.5318C24.8309 31.8318 24.424 32.0004 23.9996 32.0004H22.3996Z",
    fill: "#FF4545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19922 4.8C3.19922 3.52696 3.70493 2.30606 4.60511 1.40589C5.50528 0.505713 6.72618 0 7.99922 0L34.2616 0L44.7992 10.5376V43.2C44.7992 44.473 44.2935 45.6939 43.3933 46.5941C42.4932 47.4943 41.2723 48 39.9992 48H7.99922C6.72618 48 5.50528 47.4943 4.60511 46.5941C3.70493 45.6939 3.19922 44.473 3.19922 43.2V4.8ZM11.1992 19.2H6.39922V35.2H9.59922V28.8H11.1992C12.4723 28.8 13.6932 28.2943 14.5933 27.3941C15.4935 26.4939 15.9992 25.273 15.9992 24C15.9992 22.727 15.4935 21.5061 14.5933 20.6059C13.6932 19.7057 12.4723 19.2 11.1992 19.2ZM23.9992 19.2H19.1992V35.2H23.9992C25.2723 35.2 26.4932 34.6943 27.3933 33.7941C28.2935 32.8939 28.7992 31.673 28.7992 30.4V24C28.7992 22.727 28.2935 21.5061 27.3933 20.6059C26.4932 19.7057 25.2723 19.2 23.9992 19.2ZM31.9992 35.2V19.2H41.5992V22.4H35.1992V25.6H38.3992V28.8H35.1992V35.2H31.9992Z",
    fill: "#FF4545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1f084c415cf7dc6acd8028ae8cd49244.svg";
export { ForwardRef as ReactComponent };